import type { SystemStyleObject } from '@styled-system/css';
import css from '@styled-system/css';

import type { StyleFn } from './types';

export interface SxProp {
  sx?: SystemStyleObject;
}

const sx: StyleFn<SxProp> = ({ sx }) => css(sx);

export default sx;
